import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import Skeleton from 'react-loading-skeleton'

export const Header = ({ icon, header, subHeader, className, ...props }) => {
  return (
    <div className={clsx(className, 'flex items-center mt-4')} {...props}>
      {icon && <FontAwesomeIcon icon={icon} className="flex text-4xl sm:text-6xl text-gray-500" />}
      <div className={clsx(icon && 'ml-4')}>
        <h2 className="text-lg sm:text-3xl">{header || <Skeleton width="20ch" />}</h2>
        <h5 className="text-md sm:text-xl text-gray-500">{subHeader || (!header && <Skeleton width="40ch" />)}</h5>
      </div>
    </div>
  )
}

export default Header

export const HeaderLarge = ({ icon, iconClick, header, subHeader, className, ...props }) => {
  return (
    <div className={clsx(className, 'flex items-center mt-4')} {...props}>
      {icon && (
        <div onClick={iconClick} className="cursor-pointer">
          <FontAwesomeIcon icon={icon} className="flex text-4xl sm:text-6xl text-gray-500" />
        </div>
      )}
      <div className={clsx(icon && 'ml-4')}>
        <h2 className="text-2xl sm:text-3xl font-bold">{header || <Skeleton width="20ch" />}</h2>
        <h5 className="text-md sm:text-xl font-semibold text-gray-500">
          {subHeader || (!header && <Skeleton width="40ch" />)}
        </h5>
      </div>
    </div>
  )
}

export const Header2 = ({ icon, children, className, small, ...props }) => {
  return (
    <div className={clsx(className, 'flex items-center mb-4')} {...props}>
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={clsx('flex', small ? 'text-4xl' : 'text-4xl sm:text-6xl text-gray-500')}
        />
      )}
      <div className={clsx(icon && 'ml-4')}>
        <h2 className="text-xl font-bold">{children || <Skeleton width="20ch" />}</h2>
      </div>
    </div>
  )
}


export const HeaderNew = ({
  icon,
  iconClick,
  header,
  headerSkeleton = false,
  subHeader,
  subHeaderSkeleton = false,
  className,
  ...props
}) => {

  return (
    <div className={clsx(className, 'flex items-center mt-4')} {...props}>
      {icon && (
        <div onClick={iconClick} className="cursor-pointer">
          <FontAwesomeIcon icon={icon} className="flex text-4xl sm:text-6xl text-gray-500" />
        </div>
      )}
      <div className={clsx(icon && 'ml-4')}>
        <h2 className="text-2xl sm:text-3xl font-bold">
          {headerSkeleton && <Skeleton width="20ch" />}
          {!headerSkeleton && header}
        </h2>
        <h5 className="text-md sm:text-xl font-semibold text-gray-500">
          {subHeaderSkeleton && <Skeleton width="40ch" />}
          {!subHeaderSkeleton && subHeader}
        </h5>
      </div>
    </div>
  )
}
